import { grayIconFill } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';
import { StyleDeclarationValue, css } from 'aphrodite';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
	styles?: StyleDeclarationValue[];
}

export const UpDownIcon: React.FC<IProps> = props => {
	const { className, fillColor, styles = [] } = props;
	return (
		<SvgIcon className={`updown-icon ${css(...styles)} ${className || ''}`} height={14} width={14}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2.707 3.828V9.414H4.707V3.828L6 5.121L7.414 3.707L3.707 0L0 3.707L1.414 5.121L2.707 3.828Z'
				fill={fillColor || grayIconFill}
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7.414 8.293L6 9.707L9.707 13.414L13.414 9.707L12 8.293L10.707 9.586V4H8.707V9.586L7.414 8.293Z'
				fill={fillColor || grayIconFill}
			/>
		</SvgIcon>
	);
};
